import type { JNumber, JObject, JString } from '../types';

export interface AddressBookRecordValidationSchema extends JObject {
  type: 'object';
  properties: {
    customerKey: JNumber;
    name?: JString;
    countryCode: JString;
    stateCode: JString;
    city: JString;
    postalCode: JString;
    address1?: JString;
    address2?: JString;
    categoryKey: JNumber;
  };
  required: ['customerKey', 'countryCode', 'stateCode', 'city', 'postalCode', 'categoryKey'];
}

export type FieldsForAddressBookRecord = keyof AddressBookRecordValidationSchema['properties'];

export const ADDRESS_BOOK_LABELS: {
  [Key in FieldsForAddressBookRecord]?: string;
} = {
  address1: 'Address 1',
  address2: 'Address 2',
  city: 'City',
  countryCode: 'Country',
  name: 'Company Name',
  postalCode: 'Post Code',
  stateCode: 'State/Province',
} as const;
